import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import {
    EXPERIAN_RISK_VERY_HIGH,
    EXPERIAN_RISK_HIGH,
    EXPERIAN_RISK_MEDIUM_HIGH,
    EXPERIAN_RISK_MEDIUM,
    EXPERIAN_RISK_LOW_MEDIUM,
    EXPERIAN_RISK_LOW
} from './../../../../../constants';
import utils from './../../../../../utils/utilities';
import { capitalize } from 'lodash';

export default class ExperianCreditRatingRow extends React.Component {

    constructor(props) {
        super(props);

        this.tooltipHandlerEnter = this.tooltipHandlerEnter.bind(this);
    }

    tooltipHandlerEnter(e) {
        utils.attachTooltipToCursor(e, -100, 25)
    }

    render() {

        return (
            <tr>

                <td className="entity-title">
                    <Link className='entity-name'
                          title={this.props.entityTitle}
                          to={`/view-experian/${this.props.entityId}/${this.props.experianId}`}>{this.props.entityTitle}
                    </Link>
                    {/*<span className='entity-title__new'><span>NEW</span></span>*/}
                </td>

                <ExperianRiskCell risk={
                                    this.props.uiExperianDocument.processedDocument.delinquencyRating &&
                                    this.props.uiExperianDocument.processedDocument.delinquencyRating.risk !== 'UNDEFINED' ?
                                        this.props.uiExperianDocument.processedDocument.delinquencyRating.risk : null}
                                  trend={
                                      this.props.uiExperianDocument.processedDocument.delinquencyRating.trend &&
                                      this.props.uiExperianDocument.processedDocument.delinquencyRating.trend !==
                                      'UNDEFINED' ?
                                          this.props.uiExperianDocument.processedDocument.delinquencyRating.trend : null}
                                  tooltipContent={
                                      <ul>
                                          {
                                              this.props.uiExperianDocument.processedDocument.deliquencyRatingInfo && this.props.uiExperianDocument.processedDocument.deliquencyRatingInfo.length > 0 ?
                                                  this.props.uiExperianDocument.processedDocument.deliquencyRatingInfo.map(
                                                      (financialRatingTooltipContent, index) =>
                                                          <li key={financialRatingTooltipContent + index}>
                                                              {capitalize(financialRatingTooltipContent)}
                                                          </li>) : <li><FormattedMessage id='General_CoreFunctionality_UIText_general.notAvailableShort'/></li>
                                          }
                                      </ul>
                                  }
                                  tooltipHandlerEnter={this.tooltipHandlerEnter}
                />

                <ExperianRiskCell risk={
                                    this.props.uiExperianDocument.processedDocument.financialRating &&
                                    this.props.uiExperianDocument.processedDocument.financialRating.risk !== 'UNDEFINED' ?
                                        this.props.uiExperianDocument.processedDocument.financialRating.risk : null}
                                  trend={
                                      this.props.uiExperianDocument.processedDocument.financialRating.trend &&
                                      this.props.uiExperianDocument.processedDocument.financialRating.trend !==
                                      'UNDEFINED' ?
                                          this.props.uiExperianDocument.processedDocument.financialRating.trend : null
                                  }
                                  tooltipContent={
                                      <ul>
                                          {
                                              this.props.uiExperianDocument.processedDocument.financialRatingInfo && this.props.uiExperianDocument.processedDocument.financialRatingInfo.length > 0 ?
                                                  this.props.uiExperianDocument.processedDocument.financialRatingInfo.map(
                                                      (delinquencyRatingTooltipContent, index) =>
                                                          <li key={delinquencyRatingTooltipContent + index}>
                                                              {capitalize(delinquencyRatingTooltipContent)}
                                                          </li>) : <li><FormattedMessage id='General_CoreFunctionality_UIText_general.notAvailableShort'/></li>
                                          }
                                      </ul>
                                  }
                                  tooltipHandlerEnter={this.tooltipHandlerEnter}
                />

                <td>
                    <div className='experian-cell'>

                        {
                            this.props.uiExperianDocument.processedDocument.bankruptcyRating !== 'null' ||
                            this.props.uiExperianDocument.processedDocument.bankruptcyRating !== 'UNDEFINED' ?
                                <div className={this.props.uiExperianDocument.processedDocument.bankruptcyRating
                                    ? 'experian-red bankruptcy-bullet' : 'experian-green bankruptcy-bullet'}
                                     onMouseEnter={this.props.uiExperianDocument.processedDocument.bankruptcyRatingInfo ?
                                         this.tooltipHandlerEnter : null}>
                                    {
                                        this.props.uiExperianDocument.processedDocument.bankruptcyRatingInfo ?
                                            <div className='tooltip arrow-top'>
                                                {buildBankruptcyLiRows(
                                                    this.props.uiExperianDocument.processedDocument.bankruptcyRatingInfo)}
                                            </div>
                                            : null
                                    }
                                    {
                                        this.props.uiExperianDocument.processedDocument.bankruptcyRating ?
                                            <FormattedMessage id="General_CoreFunctionality_UIText_general.yes" />
                                            :
                                            <FormattedMessage id="General_CoreFunctionality_UIText_general.no" />
                                    }
                                </div>
                                :
                                <div className='experian-na bankruptcy'>
                                    <FormattedMessage id='General_CoreFunctionality_UIText_general.notAvailableShort'/>
                                </div>
                        }

                    </div>
                </td>

            </tr>
        )

    }

}

export class ExperianRiskCell extends React.Component {

    render() {

        let bulletClass = 'experian-na',
            label       = 'General_CoreFunctionality_UIText_general.notAvailableShort';

        switch (this.props.risk) {
            case EXPERIAN_RISK_VERY_HIGH:
                bulletClass = 'experian-red';
                label = "Dashboard_CoreFunctionality_UIText_experian.veryHighRisk";
                break;
            case EXPERIAN_RISK_HIGH:
                bulletClass = 'experian-red-orange';
                label = "Dashboard_CoreFunctionality_UIText_experian.highRisk";
                break;
            case EXPERIAN_RISK_MEDIUM_HIGH:
                bulletClass = 'experian-orange';
                label = "Dashboard_CoreFunctionality_UIText_experian.mediumHighRisk";
                break;
            case EXPERIAN_RISK_MEDIUM:
                bulletClass = 'experian-yellow';
                label = "Dashboard_CoreFunctionality_UIText_experian.mediumRisk";
                break;
            case EXPERIAN_RISK_LOW_MEDIUM:
                bulletClass = 'experian-light-green';
                label = "Dashboard_CoreFunctionality_UIText_experian.lowMediumRisk";
                break;
            case EXPERIAN_RISK_LOW:
                bulletClass = 'experian-green';
                label = "Dashboard_CoreFunctionality_UIText_experian.lowRisk";
                break;
            default:
                bulletClass = 'experian-na';
                label = "General_CoreFunctionality_UIText_general.notAvailableShort";
                break;
        }

        let trendingTerm = capitalize(this.props.trend);

        return (
            <td>
                <div className='experian-cell'>
                    <div className={bulletClass}
                         onMouseEnter={this.props.tooltipHandlerEnter}>

                        {
                            bulletClass === 'experian-na' ?
                                null
                                :
                                <div className='tooltip arrow-top'>
                                    <div>
                                        <b><FormattedMessage id='General_CoreFunctionality_UIText_general.trending' />:</b> {trendingTerm ?
                                        trendingTerm : <FormattedMessage
                                            id='General_CoreFunctionality_UIText_general.notAvailableShort' />}
                                    </div>
                                    <div>
                                        <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.experianPod.factorsLoweringScore' />:</b></div>
                                        <div>{this.props.tooltipContent ? this.props.tooltipContent : null}</div>
                                    </div>
                                </div>
                        }

                    </div>
                    <FormattedMessage id={label} />
                </div>
            </td>
        )
    }

}

function buildBankruptcyLiRows(bankruptcyRatingInfo) {

    let bankruptcyRatingInfoRows = [];
    if (bankruptcyRatingInfo) {
        for (let property in bankruptcyRatingInfo) {
            if (bankruptcyRatingInfo.hasOwnProperty(property)) {
                bankruptcyRatingInfoRows.push(<li key={property}>{capitalize(property)} <b>{bankruptcyRatingInfo[property]}</b></li>);
            }
        }
    }

    return (
        <ul>
            {bankruptcyRatingInfoRows}
        </ul>
    )

}


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/ExperianCreditRatingPod/ExperianCreditRatingRow.jsx